import React, { memo } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, IconCrown } from '@redlink/components/atoms';

export const Switch = memo(
  ({
    data = [],
    keyExtractor = (item) => item?.key,
    valueExtractor = (item) => item?.value,
    selected = data[1],
    onChange,
  }) => {
    const { styles } = useStyle();
    return (
      <View style={styles.container}>
        {data.map((item, index) => {
          const isSelected = keyExtractor(selected) === keyExtractor(item);
          const disabled = item.disabled;
          return (
            <SwitchItem
              disabled={disabled}
              selected={isSelected}
              title={valueExtractor(item)}
              onPress={() => onChange?.(item, index)}
              {...{ index }}
              totalCount={data.length}
            />
          );
        })}
      </View>
    );
  }
);

const SwitchItem = memo(
  ({ selected = false, disabled, title, onPress, index, totalCount }) => {
    const { styles } = useStyle();
    const isStartItem = index === 0;
    const isEndItem = index === totalCount - 1;
    const isMiddleItem = !isStartItem && !isEndItem;
    return (
      <TouchableOpacity
        {...{ onPress, disabled }}
        activeOpacity={0.7}
        style={[
          styles.itemContainer,
          selected && styles.itemContainerSelected,
          isStartItem && styles.itemContainerStart,
          isEndItem && styles.itemContainerEnd,
          isMiddleItem && styles.itemContainerMiddle,
          disabled && styles.itemDisabledContainer,
        ]}
      >
        {disabled && <View style={styles.iconContainer}><IconCrown size={15} /></View>}
        <Text
          numberOfLines={1}
          style={[
            styles.itemTitleText,
            selected && styles.itemTitleSelectedText,
          ]}
        >
          {title}
        </Text>
      </TouchableOpacity>
    );
  }
);

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  container: {
    flexDirection: 'row',
    overflow: 'hidden',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: colors.blue8,
  },
  itemContainer: {
    flex: 1,
    flexDirection: 'row',
    paddingHorizontal: 6,
    paddingVertical: 6,
    minWidth: 77,
    alignItems: 'center',
  },
  itemContainerStart: {
    borderEndWidth: 1,
    borderColor: colors.blue8,
  },
  itemContainerEnd: {
    borderStartWidth: 1,
    borderColor: colors.blue8,
  },
  itemContainerMiddle: {
    borderStartWidth: 1,
    borderEndWidth: 1,
    borderColor: colors.blue8,
  },
  itemContainerSelected: {
    backgroundColor: colors.blue8,
  },
  itemTitleText: {
    flex: 1,
    textAlign: 'center',
    color: colors.black,
    fontSize: 12,
  },
  itemTitleSelectedText: {
    color: colors.blue1,
  },
  itemDisabledContainer: {
    opacity: 0.4,
  },
  iconContainer: {
    position: 'absolute'
  }
}));
